import {
  toWireMortgageLender,
  toWireSecurities,
} from 'scenes/common/api/quote/marshaller/assets';
import { ADDRESS_ID, ASSET_ID } from 'scenes/common/api/quote/marshaller/ids';
import { WireAsset, WirePurpose } from 'scenes/common/api/quote/types';
import {
  anyFutureRenovationPlanned,
  getMortgageProvider,
  getMortgageProviderOther,
  getPropertyBuiltYear,
  getPurposeOfProperty,
  getSecurityFeatures,
  getPropertyInGoodCondition,
  hasAdditionalSecurityInstalled,
  hasBeenRewiredOrReplumbed,
  hasMoreThan3UnrelatedPeople,
  heritageListedAnswerRequired,
  isHeritageListed,
  isOver5Acres,
  isPropertyOwned,
  isPropertyUnderRenovation,
  isPropertyUnoccupied,
  isPropertyUsedForBusiness,
  isRentalAgreement,
  rewiredOrReplumbedAnswerRequired,
  isPropertyInGoodCondition,
  hasContentsCoverType,
} from 'scenes/landlord/selectors';
import {
  LandlordFunnelState,
  PropertyPurposeType,
} from 'scenes/landlord/types';
import { toWireBuilding } from './building';
import { toWireBuildingCoverSI } from './buildingCoverSI';
import { coverageRefIds } from './coverage';
import { partyRefIds } from './party';

const wirePurpose: { [key in PropertyPurposeType]: WirePurpose } = {
  [PropertyPurposeType.HolidaysHouse]: WirePurpose.HldHmIncm,
  [PropertyPurposeType.Rental]: WirePurpose.OwnNRented,
  [PropertyPurposeType.ShortTermRental]: WirePurpose.OwnNRentST,
  [PropertyPurposeType.PPR]: WirePurpose.OwnNLive,
  [PropertyPurposeType.Unspecified]: WirePurpose.Unspecified,
};

export const toWireAssets = (state: LandlordFunnelState): WireAsset[] => [
  {
    addressRefId: ADDRESS_ID,
    coverageRefIds: coverageRefIds(state),
    hasAddSecurity: hasAdditionalSecurityInstalled(state),
    id: ASSET_ID,
    partyRefIds: partyRefIds(state),
    isOwned: isPropertyOwned(state),
    purpose: wirePurpose[getPurposeOfProperty(state)],
    securities: hasContentsCoverType(state)
      ? toWireSecurities(getSecurityFeatures(state))
      : undefined,
    isUsedForBusiness: isPropertyUsedForBusiness(state),
    building: toWireBuilding(state),
    buildingCoverSI: toWireBuildingCoverSI(state),
    mortgageLender: toWireMortgageLender(
      getMortgageProvider(state),
      getMortgageProviderOther(state)
    ),
    rentalAgreement: isRentalAgreement(state),
    isHeritageListed:
      heritageListedAnswerRequired(getPropertyBuiltYear(state)) &&
      isHeritageListed(state),
    isRewiredOrReplumbed:
      rewiredOrReplumbedAnswerRequired(getPropertyBuiltYear(state)) &&
      hasBeenRewiredOrReplumbed(state),
    hasMaxUnrelatedOccupants: hasMoreThan3UnrelatedPeople(state),
    isMaintained: getPropertyInGoodCondition(state)
      ? isPropertyInGoodCondition(state)
      : undefined,
    isUnderConstruction: isPropertyUnderRenovation(state),
    hasPlannedConstruction:
      !isPropertyUnderRenovation(state) && anyFutureRenovationPlanned(state),
    isOver5Acres: isOver5Acres(state),
    isUnoccupied: isPropertyUnoccupied(state),
  },
];

export const assetRefIds = (state: LandlordFunnelState): string[] => [
  ...toWireAssets(state).map((asset) => asset.id),
];
